import ArrowRight from '@crehana/compass.icons.outline/ArrowRight';
import { useTranslation } from '@crehana/i18n';
import { CustomNextImage } from '@crehana/next';
import Link from 'next/link';

import { useOrgSlug } from '../hooks/use-org-slug';

const PICTOGRAM =
  'https://crehana-vercel-images-prd.imgix.net/public/lx-mf/e71bd6ee-401e-4e37-ab39-38363a5e1a5e-play-audiobook.png?auto=format&fit=clip&w=48&h=48';

export const LearningCard = () => {
  const { organizationSlug } = useOrgSlug();
  const { t } = useTranslation();

  return (
    <div className="tw-p-2 tw-border tw-border-solid tw-border-neutral-light-400 tw-rounded-1.6 tw-bg-neutral-light-100 tw-space-y-1.2 tw-h-[35.2rem] tw-flex tw-flex-col tw-overflow-hidden">
      <h3 className="tw-font-subtitle5">{t('LEARNING_CARD_TITLE')}</h3>
      <div className="tw-grow tw-w-full tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 tw-pt-2.4 tw-relative">
        <div className="tw-hidden sm:tw-flex tw-flex-col -tw-ml-3.2">
          <div className="tw-w-[16.7rem] tw-h-[16.7rem] tw-rounded-full tw-bg-success-400 tw-flex tw-items-center tw-justify-center">
            <CustomNextImage
              src={PICTOGRAM}
              width={48}
              height={48}
              alt="Play audiobook"
            />
          </div>
          <div className="tw-w-[16.7rem] tw-h-[16.7rem] tw-rounded-full tw-bg-success-200" />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-2 tw-grow">
          <div>
            <h3 className="tw-font-subtitle2 sm:tw-font-subtitle4 tw-mb-0.8">
              {t('CARDS_ENROLLED_COURSES_TITLE')}
            </h3>
            <p className="tw-font-body4 sm:tw-font-body5 tw-text-neutral-light-700 tw-mb-1.2">
              {t('CARDS_ENROLLED_COURSES_DESCRIPTION')}
            </p>
            <Link href={`/org/${organizationSlug}/learn/my-courses/enrolled/`}>
              <div className="tw-text-primary-light-500 tw-flex tw-items-center tw-gap-0.8 tw-font-subtitle3 sm:tw-font-subtitle5">
                {t('CARDS_ENROLLED_COURSES_CTA')}
                <ArrowRight size={20} className="tw-text-inherit" />
              </div>
            </Link>
          </div>

          <div>
            <h3 className="tw-font-subtitle2 sm:tw-font-subtitle4 tw-mb-0.8">
              {t('CARDS_LEARNING_PATHS_TITLE')}
            </h3>
            <p className="tw-font-body4 sm:tw-font-body5 tw-text-neutral-light-700 tw-mb-1.2">
              {t('CARDS_LEARNING_PATHS_DESCRIPTION')}
            </p>
            <Link href={`/org/${organizationSlug}/learn/my-courses/tracks/`}>
              <div className="tw-text-primary-light-500 tw-flex tw-items-center tw-gap-0.8 tw-font-subtitle3 sm:tw-font-subtitle5">
                {t('CARDS_LEARNING_PATHS_CTA')}
                <ArrowRight size={20} className="tw-text-inherit" />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
